import {
  AssistanceTypeEnum,
  AssistantIncidentSeverityEnum,
  AssistantRecommendedActionEnum,
  ConversationAuthorEnum,
  DiagnosticCodeStateEnum,
  GuidedCheckStatusEnum,
  IssueReportChannelEnum,
  ServiceProviderStatusEnum,
  ServiceRequestPriorityEnum,
  ServiceRequestStatusEnum,
} from '../../enums';

export interface ServiceRequestVehicleDto {
  id: string;
  vehicleId: string;
  vin: string;
  model: string;
  year: number;
  mileage: number;
  engine?: string;
  fuelType?: string;
}

export interface ServiceRequestDriverDto {
  id: string;
  fullName: string;
  phone?: string;
}

export interface ServiceRequestLocationDto {
  address: string;
  city: string;
  state: string;
  lat: number;
  lng: number;
  updatedAt: string;
}

export interface ServiceRequestIssueDto {
  title: string;
  driverAccount: string;
  additionalObservations?: string;
  channel: IssueReportChannelEnum;
  symptoms: string[];
  photos: string[];
}

export interface DiagnosticCodeDto {
  code: string;
  description: string;
  source: string;
  state: DiagnosticCodeStateEnum;
  occurredAt: string;
  occurrences?: number | null;
}

export interface DiagnosticReadingDto {
  name: string;
  value: string;
  stale?: boolean;
  ageSeconds?: number;
  source?: string;
  origin?: string;
}

export interface DiagnosticsSnapshotDto {
  capturedAt: string;
  codes: DiagnosticCodeDto[];
  readings: DiagnosticReadingDto[];
  adapterVersion?: string;
  adapterVoltage?: number;
  broadcastFrames?: number;
}

export interface PreliminaryAssessmentDto {
  title?: string;
  summary: string;
  cause: string;
  potentialCauses: string[];
  recommendations: string[];
}

export interface GuidedCheckDto {
  id: string;
  suggestedAction: string;
  driverStep?: string;
  outcome?: string;
  status: GuidedCheckStatusEnum;
  completedAt?: string;
}

export interface ConversationMessageDto {
  id: string;
  author: ConversationAuthorEnum;
  title?: string;
  text: string;
  createdAt: string;
}

export interface ServiceRequestTimelineEventDto {
  id: string;
  text: string;
  createdAt: string;
}

export interface ServiceProviderDto {
  id: string;
  name: string;
  address: string;
  phone?: string;
  website?: string;
  specializations: string[];
  assistanceTypes: AssistanceTypeEnum[];
  distanceMiles: number;
  mobileService: boolean;
  confirmedAvailability?: string;
  estimatedCost?: number;
  status: ServiceProviderStatusEnum;
  respondedAt?: string;
  note?: string;
}

export interface ServiceRequestDto {
  id: string;
  number: string;
  status: ServiceRequestStatusEnum;
  priority: ServiceRequestPriorityEnum;
  createdAt: string;
  updatedAt: string;
  vehicle: ServiceRequestVehicleDto;
  driver: ServiceRequestDriverDto;
  location: ServiceRequestLocationDto;
  issue: ServiceRequestIssueDto;
  diagnostics: DiagnosticsSnapshotDto;
  assessment: PreliminaryAssessmentDto;
  checks: GuidedCheckDto[];
  assistanceType?: AssistanceTypeEnum;
  providers: ServiceProviderDto[];
  selectedProviderId?: string;
  conversation: ConversationMessageDto[];
  timeline: ServiceRequestTimelineEventDto[];
  approvedBy?: string;
  approvedAt?: string;
  incidentSeverity?: AssistantIncidentSeverityEnum;
  recommendedAction?: AssistantRecommendedActionEnum;
  notes?: string;
}
